module.exports = __webpack_public_path__ + "static/media/Kanit-Regular.a82c4c3b.ttf";